import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";

const CandidateLanguageFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [language, setLanguage] = useState([]);
  const [newFormData, setNewFormData] = useState({});
  const level = [
    {label: 'A1', code: 'A1'},
    {label: 'A2', code: 'A2'},
    {label: 'B1', code: 'B1'},
    {label: 'B2', code: 'B2'},
    {label: 'C1', code: 'C1'},
    {label: 'C2', code: 'C2'},
  ]

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().candidateLanguageId) || (entity === 'candidate-language' && id)) {
      const payload = {
        ...formData,
        ...newFormData,
        candidate: id
      }
      apiCall('patch', '/api/v2/candidate-language/' + (window.App.urlVars().candidateLanguageId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCandidateLanguageList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      const payload = {
        ...data,
        candidate: id
      }
      apiCall('post', '/api/v2/candidate-language', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCandidateLanguageList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push(`/recruitment/candidate/read/${id}/candidate-language/update/` + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().candidateLanguageId) || (entity === 'candidate-language' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/candidate-language/' + (window.App.urlVars().candidateLanguageId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/language', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
    .then(response => {
      setLanguage(response.data.data?.items)
    })
    .catch(error => {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    })
  }, [])

  return (
    <div className={"candidate-language-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>


              <Field name="language" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="language"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldLanguage')}</label>
                  <span className="p-d-block">
                      <Dropdown id="language" {...input}
                                options={window.App.sortDropdownOptions(language, "name")}
                                optionValue="id"
                                optionLabel="name"
                                 onChange={(e) => {
                                  input.onChange(e.value);
                                   setFormData({
                                     ...formData,
                                     language: e.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     language: e.value
                                   })
                                 }}
                                 value={input.value}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-6"}>
              <Field name="level" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="level"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldLevel')}</label>
                  <span className="p-d-block">
                      <Dropdown id="level" 
                                  options={window.App.sortDropdownOptions(level, "label")}
                                  optionLabel="label"
                                  optionValue="code"
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      level: e.target.value
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      level: e.target.value
                                    })
                                  }}
                                  value={formData.level}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'candidate-language' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(CandidateLanguageFormComponent);
